var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
const Container = styled(ListItem, {
    shouldForwardProp: (prop) => !['showDragHandle'].includes(prop)
}) `
    padding: ${({ theme }) => theme.spacing(0.25, 2)};

    ${(props) => props.showDragHandle === false && 'padding-left: 52px;'}

    &:hover, &.Class-dragging {
        background: ${({ theme }) => theme.palette.primary.background};
    }

    &.Class-dragging {
        border-radius: 6px;
    }
`;
const showActions = `.Class-dragging &, ${Container}:hover &, ${Container}:focus-within &`;
const StyledIconContainer = styled(ListItemAvatar) `
    width: 32px;
    display: flex;
    align-items: center;

    & .MuiAvatar-root {
        width: 24px;
        height: 24px;
    }

    & .MuiSvgIcon-root,
    & svg {
        font-size: 24px;
        width: 24px;
        height: 24px;
    }
`;
const DragIconContainer = styled(ListItemIcon) `
    min-width: 36px;
    height: 36px;
    align-items: center;
    color: ${({ theme }) => theme.palette.primary.main};

    .MuiSvgIcon-root {
        opacity: 0;

        ${showActions} {
            opacity: 1;
        }
    }
`;
const ItemActions = styled(Box) `
    opacity: 0;

    ${showActions} {
        opacity: 1;
    }

    & .MuiButton-root {
        max-height: 36px;
    }

    & .MuiButton-root:not(:last-child) {
        margin-right: 6px;
    }
`;
const TitleListItemText = styled(ListItemText) `
    & > .MuiTypography-root {
        display: flex;
        align-items: center;
    }
`;
export const OrganizerSectionItem = forwardRef((props, ref) => {
    const { avatar, icon, title, actions, showDragHandle = false, isDragging = false, dragHandleProps } = props, other = __rest(props, ["avatar", "icon", "title", "actions", "showDragHandle", "isDragging", "dragHandleProps"]);
    return (_jsxs(Container, Object.assign({ ref: ref, showDragHandle: showDragHandle }, other, { className: ['OrganizerSectionItem-root', other.className, isDragging ? 'Class-dragging' : undefined], children: [showDragHandle && (_jsx(DragIconContainer, Object.assign({}, dragHandleProps, { className: ['OrganizerSectionItem-dragContainer', dragHandleProps === null || dragHandleProps === void 0 ? void 0 : dragHandleProps.className], children: _jsx(DragIndicatorIcon, {}) }))), (avatar || icon) && (_jsxs(StyledIconContainer, { className: `OrganizerSectionItem-${icon ? 'icon' : 'avatar'}`, children: [icon, avatar] })), _jsx(TitleListItemText, { className: 'OrganizerSectionItem-title', children: title }), _jsx(ItemActions, { className: 'OrganizerSectionItem-actions', children: actions })] })));
});
